import { createReducer, on } from '@ngrx/store';
import { storeThirdFilePartnerRegister } from '../../actions/file-patner-register.actions';

export interface IStateThirdFilePartnerRegister {
  file: File | null;
}

export const initialState: IStateThirdFilePartnerRegister = {
  file : null
}

export const thirdFilePartnerRegisterReducer = createReducer(
  initialState,
  on(storeThirdFilePartnerRegister, (state, { file }) => ({...state, file}))
)
